export const environment = {
  production: true,
  version: '5.16.3',
  logo: 'icetexLOGO.png',
  logoWidth: 500,
  clientType: 'icetexPROD',
  isLocalhost: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBwSRV5389-4PAb9vS_T1lP9Z5hvecEDqM',
    authDomain: 'test-credisystem.firebaseapp.com',
    projectId: 'test-credisystem',
    storageBucket: 'test-credisystem.appspot.com',
    messagingSenderId: '338504077818',
    appId: '1:338504077818:web:bbecba704505035a2c1443',
    measurementId: 'G-NVRC2W821Z'
  },

  cryptKey: '1kzEp}:E:+V}Ld[=,FuXfe#Cpq<z!',

  apiBaseUrl: 'https://api-ictx.arx-t7.com:4443/',
  apiNewBackBaseUrl: 'https://api-ictx.arx-t7.com/api/ahorro/',
  apiSSRSurl: 'https://desarrolloaws.datascoring.co:9970/',
  urlPopGrafico: 'https://desarrolloaws.datascoring.co:9922/#/',
  icetexAuthBaseUrl: 'https://devnewcredisystem.datascoring.co:8585'
};
